module.exports = __webpack_public_path__ + "images/emoji/boar.ac1028339cdfd3971f3a.png";